import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Routes, Link, useNavigate } from 'react-router-dom';
import { find, template } from 'lodash';
import { TRIMS } from '../../../../common/steps';
import { setSelectionRevealState } from '../../../../store/actions';
import { TranslateHTML } from '../../../../../core/translate';
import { buildCgiImageForCard } from '../../../../api/config/normalizeCGI';
import Footer from '../../../../components/footer/Footer';
import TrimFeaturesModal from '../features/trimFeaturesModal/TrimFeaturesModal';
import { SvgIcon } from '../../../../../core/icons';
import MoreViewsTwoD from '../../../../main/moreViews/MoreViewsTwoD';

const YourTrim = ({
  features,
  matrix,
  styleId,
  appResources,
  bottomOffset,
  onLoad,
  config,
  setBottomOffset,
}) => {
  const navigate = useNavigate();

  const { trims } = matrix;
  const trim = find(trims, { styleId });
  const { selections } = config;
  const { processSteps } = appResources;
  const { lateAvailabilityDisclaimer, trimName, cgiImageUrl } = trim;

  const trimStep = find(processSteps, { key: TRIMS });
  const header = template(trimStep.tidHeader)({
    trimName,
    driveType: trim.driveType.id,
  });
  const subheader = trimStep.tidSubHeader;
  const cgi = buildCgiImageForCard(cgiImageUrl, { small: 'gmds10' });

  const tidDetailLabel = trimStep.tidDetailsLabel;
  const standardHighlights = tidDetailLabel.replace(
    '${trimName}',
    `${trimName}`
  );

  useEffect(() => {
    onLoad();
  }, []);

  const onClose = () => {
    navigate('');
  };

  return (
    <main
      className="your-trim__container"
      style={{ paddingBottom: bottomOffset }}>
      <div className="your-trim__header">{header}</div>
      {lateAvailabilityDisclaimer && (
        <div className="your-trim__subheader">{lateAvailabilityDisclaimer}</div>
      )}
      {subheader && <div className="your-trim__subheader">{subheader}</div>}
      <div className="your-trim__image-container">
        <img className="your-trim__image" src={cgi} alt={trimName} />
        {tidDetailLabel ? (
          <Link
            to={`./features/${styleId}`}
            className="your-trim__link stat-text-link"
            data-dtm="your trim">
            {standardHighlights}
            <SvgIcon
              className="your-trim__link__icon"
              name="feature-highlights-arrow"
            />
          </Link>
        ) : (
          <Link
            to={`./features/${styleId}`}
            className="your-trim__link stat-text-link"
            data-dtm="your trim">
            <TranslateHTML value="component.common.standard.features" />
            <SvgIcon className="your-trim__link__icon" name="packages-more" />
          </Link>
        )}
      </div>
      <Footer className="gridview__footer" />
      <Routes>
        <Route
          path="/features/:styleId/*"
          element={
            <TrimFeaturesModal
              appResources={appResources}
              features={features}
              disableCompare={true}
              trimGroups={[trim]}
              isSelectionRevealed={true}
              styleId={styleId}
              selections={selections}
              setBottomOffset={setBottomOffset}
              onClose={onClose}
              onSelect={onClose}
              isPreSelected={true}
            />
          }
        />
        <Route
          path="/features/:styleId/moreviews"
          element={<MoreViewsTwoD />}
        />
      </Routes>
    </main>
  );
};

const mapDispatchToProps = {
  onLoad: () => setSelectionRevealState(),
};

export default connect(null, mapDispatchToProps)(YourTrim);
